export const PERSONA_ACTIONS = {
    Modernize: 'Modernize',
    AlreadyModern: 'Already Modern',
    Excluded: 'Excluded',
    Decommission: 'Decommission',
}